<style lang="scss">
</style>

<template>
    <div class="popup">
        <div class="popup-header">
            <p class="mb-0 fs-17 fw-b">
                <i class="fal fa-tablet-alt mr-8"></i>
                {{ $t(`${$options.name}.title`) }}
            </p>
            <div class="close" @click="$emit('close')"></div>
        </div>
        <div class="popup-content fs-17 h-auto">
            <el-form class="col-12" @submit="alreadyExists ? invite() : submit()" :error="server_error" :loading="loading" :success="success" :button-text="alreadyExists ? `${$options.name}.invite` : `${$options.name}.button`">
                <el-avatar-upload class="mb-30" v-if="!alreadyExists" v-model="user.uploadedFile" />
                <div class="form-row mb-30">
                    <el-input class="col-12 col-lg-6" v-model="user.first_name" name="firstname" rule="required" />
                    <el-input class="col-12 col-lg-6" v-model="user.last_name" name="lastname" rule="required" />
                    <el-input class="col-12" v-model="user.email" type="email" name="email" rule="required|email" />
                    <el-input class="col-12" v-if="!alreadyExists" v-model="user.password" type="password" name="password" rule="required" />
                    <el-select class="col-12" v-if="!alreadyExists" v-model="user.locale" name="language" direction="top" :options="languageOptions" :label="$t(`${$options.name}.language`)" />
                    <el-select class="col-12" v-if="alreadyExists" v-model="user.is_workspace_admin" name="is_workspace_admin" direction="top" :options="[{ value: 1, label: $t('user.update.admin')}, { value: 0, label: $t('user.update.guest')}]" :label="$t(`${$options.name}.role`)" rule="required"></el-select>
                </div>
                <template #footerLeft>
                    <span v-if="!alreadyExists" class="btn btn-outline-primary ml-auto" @click="$emit('close')">{{ $t('general.cancel') }}</span>
                    <span v-else class="btn btn-outline-primary ml-auto" @click="back()">{{ $t('general.back') }}</span>
                </template>
            </el-form>
        </div>
    </div>
</template>

<script>
import { availableLanguages } from '@/localization';
import HasForm from '@/components/forms/has-form';

export default {
    name: 'popups.user.add',

    mixins: [HasForm],

    components: {
        ElInput: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElInput"),
        ElAvatarUpload: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElAvatarUpload"),
        ElSelect: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElSelect"),
        ElForm: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElForm"),
    },

    props: {
        workspaceId: {
            type: Number,
            required: true,
            validator: function (value) {
                return value > 0
            }
        }
    },

    data() {
        return {
            user: {
                email: '',
                first_name: '',
                last_name: '',
                password: '',
                uploadedFile: '',
                locale: this.$i18n.locale,
                is_workspace_admin: 0,
            },
            alreadyExists: false,
        }
    },

    methods: {
        submit() {
            this.loading = true;
            this.$store.dispatch(`workspace/addReadOnlyUser`, { workspace_id: this.workspaceId, user: this.user })
                .then(() => {
                    this.handleSuccess()
                    this.$emit('close')
                })
                .catch(e => {
                    let alreadyExistsError = e.errors.find(error => error.field === 'email' && error.message === 'validation.unique')
                    this.alreadyExists = alreadyExistsError !== null

                    e.errors = e.errors.filter(error => error !== alreadyExistsError)
                    if (this.alreadyExists) {
                        e.errors.push({ message: 'validation.user_already_exists' })
                    }
                    this.handleError(e)
                });
        },

        invite() {
            this.loading = true;
            this.$store.dispatch('workspace/createUser', { model_id: this.workspaceId, users: [this.user] })
                .then(() => {
                    this.handleSuccess()
                    this.$emit('close')
                })
                .catch(this.handleError);
        },

        back() {
            this.alreadyExists = false
            this.server_error = null
        }
    },

    computed: {
        languageOptions() {
            return availableLanguages.map(language => ({ value: language, label: this.$t(`general.lang_${language}`) }))
        }
    }
}
</script>